<template>
    <div id="app">
        <van-nav-bar
            leftText
            leftArrow
            @click-left="backGo"
            v-if="isShowTopBar"
            :title="$store.state.topBarTitle"
            class="headerbar"
        ></van-nav-bar>
        <!-- 动态判断需要缓存的页面 -->
        <keep-alive :include="keepIncluded">
            <router-view></router-view>
        </keep-alive>
        <van-tabbar
            v-if="isShowTabBra"
            :border="false"
            v-model="tabActive"
            class="tabbar"
            @change="onIndexChange"
        >
            <van-tabbar-item v-for="(item,index) in tabbarList" :key="index">
                <span class="fz_24 text">{{item.name}}</span>
                <div
                    slot="icon"
                    class="bg-contain homeIco"
                    slot-scope="props"
                    :class="props.active ? item.active : item.inactive"
                ></div>
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>
<script>
import { setToken, checkCookies, checkWeiXin, autoLogin } from "@/utils/user";
import { loginByOpenid } from "@/api/user";
export default {
    data() {
        return {
            // 是否显示导航栏
            isShowTabBra: true,
            // 是否显示标题栏
            isShowTopBar: false,
            // 显示底部导航栏页面
            showTabBarList: ["ShopHome", "ClassifyHome", "CartTab", "UserHome"],
            // 隐藏标题栏的页面
            hiteTopBarList: [
                "UserHome",
                "ShopHome",
                "UserLogin",
                "CartTab",
                "CartHome",
                "ClassifyHome",
                "CarGoodsQuery",
                "LocationHome",
                "UserBankSelect",
                "UserBankHome"
            ],
            // 当前选中
            tabActive: 0,
            // 底部导航
            tabbarList: [
                {
                    name: "首页",
                    active: "ico-home_select",
                    inactive: "ico-home"
                },
                {
                    name: "分类",
                    active: "ico-classify_select",
                    inactive: "ico-classify"
                },
                {
                    name: "购物车",
                    active: "ico-shoppingcart_select",
                    inactive: "ico-shoppingcart"
                },
                {
                    name: "我的",
                    active: "ico-user_select",
                    inactive: "ico-user"
                }
            ]
        };
    },
    computed: {
        // 显示底部导航栏页面
        isApp() {
            return this.$store.state.isApp;
        },
        // 需要缓存的页面
        keepIncluded() {
            return this.$store.state.keep.keepIncluded;
        },
        tabSelectIndex() {
            return this.$store.state.tabSelectIndex;
        }
    },
    watch: {
        isApp: {
            // 返回时保持当前选中状态同步
            handler(v) {
                if (v) {
                    const me = this;
                    me.showTabBarList = me.showTabBarList.filter(item => {
                        return item != "ClassifyHome";
                    });
                    me.tabbarList = me.tabbarList.filter(item => {
                        return item.name != "分类";
                    });
                    window.document.documentElement.setAttribute(
                        "data-theme",
                        "app"
                    );
                    // setTimeout(() => {
                    //     window.document.documentElement.setAttribute(
                    //         "data-theme",
                    //         ""
                    //     );
                    // }, 5000);
                }
            },
            immediate: true
        },
        $route(to, from) {
            const me = this,
                name = to.name;
            let isShowTabBra = false,
                isShowTopBar = true;
            // 检查是否隐藏底部导航栏
            if (me.showTabBarList.indexOf(name) > -1) {
                isShowTabBra = true;
            }
            // 检查是否隐藏标题栏
            if (me.hiteTopBarList.indexOf(name) > -1) {
                isShowTopBar = false;
            } else {
                me.$store.state.topBarTitle = to.meta.title;
            }
            me.isShowTabBra = isShowTabBra;
            me.isShowTopBar = isShowTopBar;
        },
        tabSelectIndex: {
            // 返回时保持当前选中状态同步
            handler(v) {
                this.showTabBarList.filter((item, index) => {
                    //  console.log(item, index, this.tabSelectIndex)
                    if (v == item) {
                        this.tabActive = index;
                    }
                });
            },
            immediate: true
        }
    },
    beforeCreate() {
        const me = this,
            store = me.$store,
            state = store.state;
        // 检查是否开发环境
        if (process.env.VUE_APP_ISDEV) {
            state.isDev = true;
        }
        // 检查是否八保舟环境
        if (process.env.VUE_APP_ISAPP) {
            state.isApp = true;
        }
        // app开发模式
        // window.document.documentElement.setAttribute("data-theme", "app");
        if (state.isApp) {
            // 八保舟自动登录
            autoLogin();
        } else {
            // console.log("检查Cookies,如果通过可以自动登录");
            checkCookies();
            // 检查是否微信环境
            checkWeiXin();
            let openid = state.openid;
            if (!state.isLogin && state.isDev) {
                openid = process.env.VUE_APP_OPENID;
            }
            // console.log("当前登录状态:", state.isLogin, ",当前openid:", openid);
            // 如果用户token过期,并且具有openid,使用openid自动登录
            if (!state.isLogin && openid) {
                // console.log("用户token过期,尝试使用openid自动登录");
                // 尝试使用openid自动登录
                loginByOpenid({ openid: openid })
                    .then(res => {
                        // console.log("openid自动登录成功");
                        setToken(res.headers.h5authorization, openid);
                    })
                    .catch(res => {});
            }
        }
        state.milieuTag = process.env.VUE_APP_CURRENTMODE;
    },
    methods: {
        onIndexChange(newIndex, oldIndex) {
            // //console.log("onIndexChange", this.$route.name);
            const next = this.showTabBarList[newIndex];
            // 避免重复触发路由导致出错
            if (this.$route.name !== next) {
                // 直接通过link跳转会报错
                this.$router.push({ name: next });
            }
        }
    }
};
</script>

